import type { SuccessScore } from '@mlm/shared';
import { SUCCESS_SCORE_MAX, type SuccessScoreComponent } from '@mlm/shared/coaching';

export const SCORE_LABELS: Record<SuccessScoreComponent, string> = {
  actions: 'Action completion',
  morningRitual: 'Morning ritual',
  mindset: 'Mindset practice',
  alignment: 'Alignment practice',
  eveningReview: 'Evening review',
  goalProgress: 'Goal progress',
};

/** The parts of the score this build can move, in the order they raise it fastest. */
const TIPS: Array<[SuccessScoreComponent, string]> = [
  ['actions', 'Complete your remaining priority actions.'],
  ['mindset', "Repeat today's affirmation, write your 369 or add to your vision board."],
  ['alignment', "Read today's guidance, breathe or listen to a frequency in Align."],
  ['goalProgress', 'Update a goal or complete a milestone.'],
];

/** The next thing that would raise today's score, or null when those parts are full. */
export function scoreTip(score: SuccessScore): string | null {
  const tip = TIPS.find(([c]) => score.breakdown[c] < SUCCESS_SCORE_MAX[c]);
  return tip ? tip[1] : null;
}

/** The part `scoreTip` is about, so the score ring can mark it. */
export function scoreTipPart(score: SuccessScore): SuccessScoreComponent | null {
  return TIPS.find(([c]) => score.breakdown[c] < SUCCESS_SCORE_MAX[c])?.[0] ?? null;
}
